import script from "./ar-viewer.vue?vue&type=script&setup=true&lang=js"
export * from "./ar-viewer.vue?vue&type=script&setup=true&lang=js"

import "./ar-viewer.vue?vue&type=style&index=0&id=3ba72ef7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ba72ef7"]])

export default __exports__